/* eslint-disable no-empty */
import React, { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import {
    Button,
    Col,
    Flex,
    Gap,
    InputField,
    Row,
    Typography,
} from "../../../ppui";
import { removeUnderScrSpCharSpaceBet } from "../../../utils/common";
import useCommonfn from "../../../utils/useCommonfn";
import StatutoryComplianceView from "./compliance-view";

const StatutorycomplianceInformation = () => {
    const {navigateToDashBoard}=useCommonfn()
    const { fetchData } = useAPIHandler()
    const [complianceData, setComplianceData] = useState([]);
    const [complianceViewData, setcomplianceViewData] = useState({});
    const [loading, setLoading] = useState(false)
    const [loadingUi, setLoadingUi] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [setOpenComplianceModal, setOpenStatutoryComplianceModal] =
        useState(false);

    const handleOpenStatutoryComplianceModal = () =>
        setOpenStatutoryComplianceModal(true);
    const handleCloseStatutoryComplianceModal = () =>
        setOpenStatutoryComplianceModal(false);
    // const[errors,setErrors]=useState({})
    const fetchBranchData = async () => {
        try {
            setLoadingUi(true);
            const result = await fetchData({
                url: 'organization-statutory/complience',
                method: 'GET',
            });

            setComplianceData(result?.data)
            setcomplianceViewData(result?.data)
            setLoadingUi(false);
        } catch (error) {
            setLoadingUi(false)
        }
    }
    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        setComplianceData((prevData) => ({
            ...prevData,
            [name]: removeUnderScrSpCharSpaceBet(value)
        }))

    }
    const handleSubmit = async () => {
        const { nic_code, lic_code } = complianceData
        try {
            const url = "organization-statutory/complience";
            const payload = {
                url: url,
                method: 'POST',
                data: {
                    nic_code,
                    lic_code,
                }
            }
            setLoading(true)
            const addData = await fetchData(payload)
            if (addData.status === 'success') {
                fetchBranchData()
            }
            handleCloseStatutoryComplianceModal()
            setLoading(false)

        } catch (error) {
            setLoading(false)

        }
    }
    useEffect(() => {
        fetchBranchData(complianceData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    // Modal


    if (loadingUi) {
        return <p>Loading ui...</p>
    }
    return (
        !(complianceViewData?.org_id) ? (
            <>
                <Typography variant="h5">Compliance Information</Typography>

                <Row rowGap>
                    <Col sm={12} md={6}>
                        <InputField
                            fullWidth
                            name="nic_code"
                            label="NIC Code"
                            placeholder="Type Here..."
                            type="tel"
                            value={complianceData?.nic_code}
                            valueSinc={!!complianceData?.nic_code}
                            onChange={(e) => handleChange(e.target.value, "nic_code")}
                        />
                    </Col>

                    <Col sm={12} md={6}>
                        <InputField
                            fullWidth
                            name="lic_code"
                            label="LIC Code "
                            placeholder="Type Here..."
                            type="tel"
                            value={complianceData?.lic_code}
                            valueSinc={!!complianceData?.lic_code}
                            onChange={(e) => handleChange(e.target.value, "lic_code")}
                        />
                    </Col>
                </Row>

                <Gap height={50} />
                <Flex justifyContent="flex-end" gap={"10"}>
                    <Button onClick={navigateToDashBoard} variant="outlined">
                        Cancel
                    </Button>

                    <Button color="primary" onClick={() => handleSubmit()} variant="contained" loading={loading}>
                        Save
                    </Button>
                </Flex>
            </>
        ) : (<StatutoryComplianceView

            handleChange={handleChange}
            complianceData={complianceData}
            complianceViewData={complianceViewData}
            handleCloseStatutoryComplianceModal={handleCloseStatutoryComplianceModal}
            setOpenComplianceModal={setOpenComplianceModal}
            handleSubmit={handleSubmit}
            loading={loading}
            handleOpenStatutoryComplianceModal={handleOpenStatutoryComplianceModal}

        />)
    );
};

export default StatutorycomplianceInformation;
